import { render } from "./YearWeekSelector.vue?vue&type=template&id=5aaa8641&scoped=true"
import script from "./YearWeekSelector.vue?vue&type=script&lang=js"
export * from "./YearWeekSelector.vue?vue&type=script&lang=js"

import "./YearWeekSelector.vue?vue&type=style&index=0&id=5aaa8641&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaa8641"]])

export default __exports__